import{a as r}from"./chunk-2HA4XQFN.js";var n=r(t=>!(!t.startsWith("#")||t.length!==4&&t.length!==7&&t.length!==5&&t.length!==9||t.search(/[^a-fA-F\d#]/)>=0),"validHex");export{n as a};
